import React, { ReactNode } from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

const DetailsStyled = styled.details`
  margin: 0 auto;
  width: 100%;
  ${media.lessThan('medium')`
    width: 90vw;
  `}
  box-sizing: border-box;
  border: solid 0.2rem #ddd;
  & > * {
    pointer-events: auto;
    margin: 0.5rem 1rem 1rem 1rem;
  }
  ${media.lessThan('large')`
    &[open]{
    & > summary:after {
      content: '–';
    }
    }
  `}
`;
const Summary = styled.summary`
  display: block;
  text-align: center;
  position: relative;
  font-size: 1.1rem;
  color: #444;
  padding: 0.5rem;
  pointer-events: none;
  ${media.lessThan('large')`
    pointer-events: auto;
    &:after {
      content: '+';
      position: absolute;
      width: 1rem;
      right: 1rem;
      font-size: 1.2em;
      line-height: 1em;
  `}
`;

type Props = {
  children: ReactNode;
  summary: string;
  className?: string;
};

export const ResponsiveDetails: React.VFC<Props> = ({
  children,
  summary,
  className,
}) => {
  return (
    <DetailsStyled
      open={typeof window !== `undefined` && window.innerWidth > 1170}
      className={className}
    >
      <Summary>{summary}</Summary>
      {children}
    </DetailsStyled>
  );
};
